module.exports = __webpack_public_path__ + "img/Achievement.da28c366.svg";